import { motion } from "framer-motion";
import aws from "../assets/certs/aws-sa.png";
import securityplus from "../assets/certs/securityplus.png";
import networkplus from "../assets/certs/networkplus.png";
import az104 from "../assets/certs/az104.png";
import itil from "../assets/certs/itilv4.png";
import linux from "../assets/certs/linux-essentials.png";
import psm from "../assets/certs/scrum-master.png";

export default function Certifications() {
  const certs = [
    {
      name: "AWS Certified Solutions Architect – Associate",
      img: aws,
      link: "https://www.credly.com/badges/YOUR-AWS-LINK",
    },
    {
      name: "CompTIA Security+",
      img: securityplus,
      link: "https://www.credly.com/badges/5236da82-2468-48cd-9a0d-ad851cd419c7/public_url",
    },
    {
      name: "CompTIA Network+",
      img: networkplus,
      link: "https://www.credly.com/badges/1faf34bb-16ad-483f-aaa5-4c2c0ef2d428/public_url",
    },
    {
      name: "Microsoft AZ-104",
      img: az104,
      link: "https://learn.microsoft.com/api/credentials/share/en-us/StivensMejiaCornelio-3753/B0F9AA75D9ACE25B?sharingId=F82BBC4CD1CCCDFB",
    },
    {
      name: "ITIL v4 Foundation",
      img: itil,
      link: "https://www.credly.com/badges/YOUR-ITILV4-LINK",
    },
    {
      name: "LPI Linux Essentials",
      img: linux,
      link: "https://www.credly.com/badges/YOUR-LINUX-LINK",
    },
    {
      name: "Professional Scrum Master I (PSM I)",
      img: psm,
      link: "https://www.credly.com/badges/32f2dfeb-cf07-47e2-a800-715762152c3f/public_url",
    },
  ];

  return (
    <motion.section
      id="certifications"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="min-h-screen px-6 py-20 bg-white dark:bg-gray-900 text-gray-800 dark:text-white"
    >
      <h2 className="text-5xl font-bold mb-10 border-b-4 border-blue-500 w-fit">
        Certifications
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-4 gap-y-8">
        {certs.map((cert, index) => (
          <a
            key={index}
            href={cert.link}
            target="_blank"
            rel="noopener noreferrer"
            title={cert.name}
            className="hover:scale-105 transition-transform flex justify-center"
          >
            <img
              src={cert.img}
              alt={cert.name}
              className="w-40 h-40 object-contain"
            />
          </a>
        ))}
      </div>
    </motion.section>
  );
}
